import React from 'react';
import {ReactComponent as PageNotFoundImageSvg} from 'resources/images/errorPage/Illustration_Error_404.svg';

export function ErrorNotFound() {
  return <PageNotFoundImageSvg />;
}
